<template>
  <div>
    <b-form-group>
                    <b-form-select
                      v-model="provider"
                      size="md"
                      :options="optionsProvider"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="0"
                        >
                          Todos
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <b-row>
                    <b-col lg="12" class="text-center">
                      <b-button @click="generateExcelFile">
                        Exportar Reporte
                      </b-button>
                    </b-col>
                  </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from "file-saver";
import { mapState } from "vuex";
export default {
name:"ReportTechnician",
data(){
   return {
    provider:0,
    optionsProvider:[],
    
   }

},
computed:{
  ...mapState("module", ["options", "name", "perfil","username","idProvider"])
},
created(){
    this.getFilteredProviders();
},
methods:{

 
    async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers?limit=1000&page=1&pagination=false"
        );

        const data = response.data.map((row) => {
          return {
            value: row.user,
            text: row.user,
          };
        });
        this.optionsProvider = data;
      } catch (error) {
        console.log(error);
      }
    },
    async generateExcelFile() {
  this.$store.commit("SET_LOADING", true);
  try {
    let providerName = this.isProfileProvider ? this.idProvider : this.provider;
    const response = await axios.post(
      process.env.VUE_APP_ORDERS_CORE_BASE_EXT + "/os-report/tecnicos",
      { idProv: providerName },
      { responseType: "blob" }
    );

    FileSaver.saveAs(response.data, "Tecnicos.xlsx");
    let values = {
          variant: "success",
          msg: "Se ha generado el reporte exitosamente. ",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
    this.$emit("update:showModalReport", false);
  } catch (error) {
     let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
  } finally {
    this.$store.commit("SET_LOADING", false);
    setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
  }
},
 
}
}
</script>

<style>

</style>